export default "__VITE_ASSET__CL5urKNx__"